import { render } from "./OrderSettingsPage.vue?vue&type=template&id=ba643298"
import script from "./OrderSettingsPage.vue?vue&type=script&lang=js"
export * from "./OrderSettingsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__